import React, { Component } from 'react';
import {
    FormGroup,
    Input,
    Label,
    InputGroup,
} from 'reactstrap';

function DataFormTextGroup(props) {
    return (
        <InputGroup>
            {/* <InputGroupAddon
                addonType="prepend">
                <InputGroupText>{props.label}</InputGroupText>
            </InputGroupAddon> */}
            <Input
                name={props.name}
                placeholder={props.label}
                onKeyPress={props.onKeyPress}
                value={props.disabled ? '' : props.value}
                onChange={props.onChange}
                disabled={props.disabled}
            />
        </InputGroup>
    );
}

function DataFormCheckGroup(props) {
    return (
        <FormGroup check>
            <Label check>
                <Input
                    className="border-none"
                    type="checkbox"
                    name={props.name}
                    checked={!props.disabled && props.checked}
                    onChange={props.onChange}
                    disabled={props.disabled}
                /> 
                {/* {props.label} */}
            </Label>
        </FormGroup>
    );
}

class DataFormRow extends Component {

    render() {
        const symbol = this.props.type === 'number' ? '#' : '$';
        const multiplierSymbol = this.props.keyBase.indexOf('accounts') > -1 ? '' : 'M';
        return (
            <tr>
                <td className="text-left"><strong>{this.props.label}</strong></td>

                <td className='p-1 pr-0 tableColumnDark'>
                    <DataFormCheckGroup
                        clientToken={this.props.clientToken}
                        label="Current"
                        name={this.props.keyBase + '_cur'}
                        checked={this.props.valBase}
                        onChange={this.props.onBooleanChange}
                    />
                </td>
                <td className='p-1 pr-0 tableColumnDark'>
                    <DataFormCheckGroup
                        clientToken={this.props.clientToken}
                        label="Previous"
                        name={this.props.keyBase + '_prev'}
                        checked={this.props.valPrev}
                        onChange={this.props.onBooleanChange}
                        disabled={!this.props.showComparison}
                    />
                </td>
                <td className='p-1 pr-0 tableColumnDark'>
                    <DataFormTextGroup
                        clientToken={this.props.clientToken}
                        label={symbol + multiplierSymbol }
                        name={this.props.keyBase + '_value_min'}
                        value={this.props.valMin}
                        onChange={this.props.onTextChange}
                        onKeyPress={this.props.handleKeyUp}
                    />
                </td>
                <td className='p-1 pr-0 tableColumnDark'>
                    <DataFormTextGroup
                        clientToken={this.props.clientToken}
                        label={ symbol + multiplierSymbol }
                        name={this.props.keyBase + '_value_max'}
                        value={this.props.valMax}
                        onChange={this.props.onTextChange}
                        onKeyPress={this.props.handleKeyUp}
                    />
                </td>

                <td className='p-1 pr-0'>
                    <DataFormCheckGroup
                        clientToken={this.props.clientToken}
                        label={"Growth (" + symbol + ")"}
                        name={this.props.keyBase + '_growth'}
                        checked={this.props.valGrowth}
                        onChange={this.props.onBooleanChange}
                        disabled={!this.props.showComparison}
                    />
                </td>
                <td className='p-1 pr-0'>
                    <DataFormTextGroup
                        clientToken={this.props.clientToken}
                        label={ symbol + multiplierSymbol }
                        name={this.props.keyBase + '_growth_min'}
                        value={this.props.valGrowthMin}
                        onChange={this.props.onTextChange}
                        disabled={!this.props.showComparison}
                        onKeyPress={this.props.handleKeyUp}
                    />
                </td>
                <td className='p-1 pr-0'>
                    <DataFormTextGroup
                        clientToken={this.props.clientToken}
                        label={ symbol + multiplierSymbol }
                        name={this.props.keyBase + '_growth_max'}
                        value={this.props.valGrowthMax}
                        onChange={this.props.onTextChange}
                        disabled={!this.props.showComparison}
                        onKeyPress={this.props.handleKeyUp}
                    />
                </td>

                <td className='p-1 pr-0 tableColumnDark'>
                    <DataFormCheckGroup
                        clientToken={this.props.clientToken}
                        label="Growth (%)"
                        name={this.props.keyBase + '_growth_percent'}
                        checked={this.props.valGrowthPercent}
                        onChange={this.props.onBooleanChange}
                        disabled={!this.props.showComparison}
                    />
                </td>
                <td className='p-1 pr-0 tableColumnDark'>
                    <DataFormTextGroup
                        clientToken={this.props.clientToken}
                        label="%"
                        name={this.props.keyBase + '_growth_percent_min'}
                        value={this.props.valGrowthPercentMin}
                        onChange={this.props.onTextChange}
                        disabled={!this.props.showComparison}
                        onKeyPress={this.props.handleKeyUp}
                    />
                </td>
                <td className='p-1 pr-0 tableColumnDark'>
                    <DataFormTextGroup
                        clientToken={this.props.clientToken}
                        label="%"
                        name={this.props.keyBase + '_growth_percent_max'}
                        value={this.props.valGrowthPercentMax}
                        onChange={this.props.onTextChange}
                        disabled={!this.props.showComparison}
                        onKeyPress={this.props.handleKeyUp}
                    />
                </td>
            </tr>
        );
    }
}

export default DataFormRow;
